import React from "react";
import { Table, Badge } from "reactstrap";
import moment from "moment";

const zambiaSchedule = [
  { id: 1,  topic: "Attitudes for Business Success",                                                       duration: "3 Days", dates: "03 – 05 Jun 2026", start: "2026-06-03" },
  { id: 2,  topic: "Turbulence-Proof Leader Level 1-6",                                                   duration: "3 Days", dates: "10 – 12 Jun 2026", start: "2026-06-10" },
  { id: 3,  topic: "HR Analytics & Artificial Intelligence",                                               duration: "3 Days", dates: "17 – 19 Jun 2026", start: "2026-06-17" },
  { id: 4,  topic: "Procurement Management",                                                               duration: "3 Days", dates: "01 – 03 Jul 2026", start: "2026-07-01" },
  { id: 5,  topic: "Presentation Skills",                                                                  duration: "3 Days", dates: "15 – 17 Jul 2026", start: "2026-07-15" },
  { id: 6,  topic: "Application of AI for Finance",                                                       duration: "3 Days", dates: "29 – 31 Jul 2026", start: "2026-07-29" },
  { id: 7,  topic: "Compliant Banker",                                                                    duration: "3 Days", dates: "12 – 14 Aug 2026", start: "2026-08-12" },
  { id: 8,  topic: "Conflict Resolution Skills for Managers",                                             duration: "3 Days", dates: "19 – 21 Aug 2026", start: "2026-08-19" },
  { id: 9,  topic: "Success-Prone Manager Level 1-6",                                                     duration: "3 Days", dates: "26 – 28 Aug 2026", start: "2026-08-26" },
  { id: 10, topic: "Understanding Employment Law in Zambia",                                              duration: "3 Days", dates: "09 – 11 Sep 2026", start: "2026-09-09" },
  { id: 11, topic: "Risk Management",                                                                      duration: "3 Days", dates: "23 – 25 Sep 2026", start: "2026-09-23" },
  { id: 12, topic: "Target Marketing for Marketing and Sales Executives",                                 duration: "3 Days", dates: "07 – 09 Oct 2026", start: "2026-10-07" },
  { id: 13, topic: "Emotional Intelligence for Senior Executives",                                        duration: "3 Days", dates: "14 – 16 Oct 2026", start: "2026-10-14" },
  { id: 14, topic: "Application of AI for Marketing",                                                     duration: "3 Days", dates: "21 – 23 Oct 2026", start: "2026-10-21" },
  { id: 15, topic: "Estate Management",                                                                   duration: "3 Days", dates: "04 – 06 Nov 2026", start: "2026-11-04" },
  { id: 16, topic: "Performance Management and Enterprise Success",                                       duration: "3 Days", dates: "11 – 13 Nov 2026", start: "2026-11-11" },
  { id: 17, topic: "Negotiation and Collective Bargaining for HR Professionals",                          duration: "3 Days", dates: "18 – 20 Nov 2026", start: "2026-11-18" },
  { id: 18, topic: "Building Strong Corporate Brands",                                                    duration: "3 Days", dates: "02 – 04 Dec 2026", start: "2026-12-02" },
  { id: 19, topic: "Capacity Building for Insurance Professionals",                                      duration: "3 Days", dates: "16 – 18 Dec 2026", start: "2026-12-16" },
  { id: 20, topic: "Mastering Supervision",                                                               duration: "3 Days", dates: "06 – 08 Jan 2027", start: "2027-01-06" },
  { id: 21, topic: "Report Writing and Minutes Taking for Corporate Secretaries",                        duration: "3 Days", dates: "13 – 15 Jan 2027", start: "2027-01-13" },
  { id: 22, topic: "Train the Trainer",                                                                   duration: "3 Days", dates: "20 – 22 Jan 2027", start: "2027-01-20" },
  { id: 23, topic: "Business Continuity Planning",                                                       duration: "3 Days", dates: "27 – 29 Jan 2027", start: "2027-01-27" },
  { id: 24, topic: "Workers Education for Trade Unions",                                                 duration: "3 Days", dates: "10 – 12 Feb 2027", start: "2027-02-10" },
  { id: 25, topic: "Strategies for Minimising Non-Performing Loans",                                     duration: "3 Days", dates: "24 – 26 Feb 2027", start: "2027-02-24" },
  { id: 26, topic: "Smart Excel for Senior Executives",                                                  duration: "3 Days", dates: "03 – 05 Mar 2027", start: "2027-03-03" },
  { id: 27, topic: "Maintenance and Facilities Management",                                              duration: "3 Days", dates: "17 – 19 Mar 2027", start: "2027-03-17" },
  { id: 28, topic: "HR Adding Value to the Business",                                                    duration: "3 Days", dates: "07 – 09 Apr 2027", start: "2027-04-07" },
  { id: 29, topic: "Ethical Recruitment for Labour Migration",                                           duration: "3 Days", dates: "14 – 16 Apr 2027", start: "2027-04-14" },
  { id: 30, topic: "Prevention and Addressing Discrimination, Violence and Harassment in a Workplace",  duration: "3 Days", dates: "21 – 23 Apr 2027", start: "2027-04-21" },
];

const GOLD = "#c9a227";
const DARK = "#1a1a1a";

export default function ZambiaTrainingTable() {
  const today = moment();

  let lastMonth = null;

  return (
    <Table style={{ borderTop: "none", textAlign: "left", borderCollapse: "separate", borderSpacing: 0 }}>
      <thead>
        <tr style={{ backgroundColor: DARK }}>
          <th style={{ position: "sticky", top: "68px", zIndex: 10, backgroundColor: DARK, fontSize: "15px", color: GOLD, border: "none", paddingTop: "14px", paddingBottom: "14px" }}>#</th>
          <th style={{ position: "sticky", top: "68px", zIndex: 10, backgroundColor: DARK, fontSize: "15px", color: GOLD, border: "none" }}>TRAINING TOPICS</th>
          <th style={{ position: "sticky", top: "68px", zIndex: 10, backgroundColor: DARK, fontSize: "15px", color: GOLD, border: "none", textAlign: "center" }}>DURATION</th>
          <th style={{ position: "sticky", top: "68px", zIndex: 10, backgroundColor: DARK, fontSize: "15px", color: GOLD, border: "none", textAlign: "right" }}>DATES</th>
        </tr>
      </thead>
      <tbody>
        {zambiaSchedule.map((item, index) => {
          const startMoment = moment(item.start);
          const monthLabel = startMoment.format("MMMM YYYY");
          const isNewMonth = monthLabel !== lastMonth;
          lastMonth = monthLabel;

          const endMoment = startMoment.clone().add(2, "days");
          const isPast = endMoment.isBefore(today, "day");
          const isOngoing = !isPast && startMoment.isSameOrBefore(today, "day");
          const isThisWeek = !isPast && !isOngoing && startMoment.isSameOrBefore(moment().add(7, "days"), "day");
          const isUpcoming = !isPast && !isOngoing && !isThisWeek;

          const rowBg = isPast
            ? "#f5f5f5"
            : index % 2 === 0 ? "#fdf6e3" : "#fff8e7";

          return (
            <React.Fragment key={item.id}>
              {isNewMonth && (
                <tr>
                  <td
                    colSpan={4}
                    style={{
                      backgroundColor: GOLD,
                      color: DARK,
                      fontWeight: "700",
                      fontSize: "13px",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      padding: "6px 12px",
                      border: "none",
                    }}
                  >
                    {monthLabel}
                  </td>
                </tr>
              )}
              <tr style={{ backgroundColor: rowBg, opacity: isPast ? 0.65 : 1 }}>
                <th scope="row" style={{ border: "none", color: "#555", fontWeight: "500", verticalAlign: "middle" }}>
                  {index + 1}
                </th>
                <td style={{ border: "none", fontWeight: "600", verticalAlign: "middle" }}>
                  {item.topic}
                  {isOngoing && (
                    <Badge style={{ backgroundColor: "#17d0cf", color: "#fff", marginLeft: "8px", fontSize: "10px", fontWeight: "700" }}>
                      ONGOING
                    </Badge>
                  )}
                  {isThisWeek && (
                    <Badge style={{ backgroundColor: GOLD, color: DARK, marginLeft: "8px", fontSize: "10px", fontWeight: "700" }}>
                      THIS WEEK
                    </Badge>
                  )}
                  {isUpcoming && (
                    <Badge style={{ backgroundColor: "#28a745", color: "#fff", marginLeft: "8px", fontSize: "10px", fontWeight: "700" }}>
                      UPCOMING
                    </Badge>
                  )}
                  {isPast && (
                    <Badge style={{ backgroundColor: "#dc3545", color: "#fff", marginLeft: "8px", fontSize: "10px", fontWeight: "700" }}>
                      PAST
                    </Badge>
                  )}
                </td>
                <td style={{ border: "none", textAlign: "center", verticalAlign: "middle", color: "#555" }}>
                  {item.duration}
                </td>
                <td style={{ border: "none", textAlign: "right", fontWeight: "700", verticalAlign: "middle", color: DARK, whiteSpace: "nowrap" }}>
                  {item.dates}
                </td>
              </tr>
            </React.Fragment>
          );
        })}
      </tbody>
    </Table>
  );
}
